import CalendarWeek from './CalendarWeek';
import { connect } from 'react-redux';

// Selectors
import { getFilteredAvailableDays } from 'store/reducers/availableTimes/selectors';
import {
  getPromotionStartDate,
  getPromotionEndDate,
  getPromoDaysOfWeekArray
} from 'store/reducers/promotions/selectors';

const mapStateToProps = state => ({
  availableDays: getFilteredAvailableDays(state),
  promotionStartDate: getPromotionStartDate(state),
  promotionEndDate: getPromotionEndDate(state),
  promotionDaysOfWeek: getPromoDaysOfWeekArray(state)
});

export default connect(mapStateToProps)(CalendarWeek);



// WEBPACK FOOTER //
// ./src/components/molecules/CalendarWeek/CalendarWeekContainer.js